<template>
  <div class="tags-wrap">
    <AddNewTag />
    <h1>List of tags</h1>
    <p>
      A list of already existing tags.
    </p>
    <div class="controls">
      <div class="left">
        <a-select
        v-model="bulk"
          default-value="Bulk Actions"
          style="
            width: 120px;
            background: #ffffff;
            box-sizing: border-box;
            border-radius: 2px;
          "
          @change="handleChange"
        >
          <a-select-option value="delete">
            Delete
          </a-select-option>
        </a-select>
        <a-button
          @click="deleteSelected"
          style="
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 24px;
            height: 32px;
            width: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          Apply
        </a-button>
      </div>
      <div class="right">
        <input
          type="text"
          style="width: 210px"
          placeholder="Type tag name here..."
          v-model="searchString"
        />
        <a-button
          @click="search"
          style="
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 24px;
            height: 32px;
            width: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          Search
        </a-button>
      </div>
    </div>
    <TagsWrapper />
    <TagPagination />
  </div>
</template>

<script>
import AddNewTag from "@/components/admin/newTagsComponents/AddNewTag.vue";
import TagsWrapper from "@/components/admin/newTagsComponents/TagsWrapper.vue";
import TagPagination from "@/components/admin/newTagsComponents/TagPagination.vue";
export default {
  components: {
    AddNewTag,
    TagsWrapper,
    TagPagination,
  },
  data() {
    return {
      searchString: "",
      bulk: "Bulk Actions",
    };
  },
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`);
    },
    search() {
      this.EventBus.$emit("searchString", this.searchString);
    },
    deleteSelected() {
      if (this.bulk == "delete") this.EventBus.$emit("deleteSelected");
    },
  },
};
</script>

<style scoped lang='scss'>
.tags-wrap {
  padding: 25px;
  background: #ffffff;
  border: 1px solid #dfe1e6;
  box-sizing: border-box;
  border-radius: 2px;
  h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    color: #001529;
    border-bottom: 1px solid #dfe1e6;
    padding: 0 0 16px 0;
  }
  p {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #001529;
    max-width: 850px;
    margin: 16px 0 25px 0;
  }
  .controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left,
    .right {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .left {
      min-width: 240px;
    }
    .right {
      min-width: 330px;
      input {
        background: #ffffff;
        border: 1px solid #dfe1e6;
        box-sizing: border-box;
        border-radius: 2px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
}
</style>